import { APP_NAME } from '@zet/end-points'

import { AnalyticsProvider, Config, EventPayload, User } from './types'

let activeAnalyticsProviders: AnalyticsProvider[] = []

const blockedEvents = [
  'screen_view',
  'click_action',
  'banner_view',
  'widget_view',
]
function callProviderFunctions<U extends keyof AnalyticsProvider>(
  fName: U,
  ...args: Parameters<AnalyticsProvider[U]>
) {
  activeAnalyticsProviders.forEach((provider) => {
    const targetFunction = provider[fName]
    if (typeof targetFunction === 'function') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      targetFunction(...args) //TODO: fix TS error
    }
  })
}

let moengageInstance: AnalyticsProvider | null = null
// let mixpanelInstance: AnalyticsProvider | null = null

// export const initMixpanel = async (config: Config) => {
//   const { MixpanelConfig } = await import('./mixpanel')
//   mixpanelInstance = new MixpanelConfig(config)
//   activeAnalyticsProviders.push(mixpanelInstance)
//   return mixpanelInstance
// }

export const initMoengage = async (config: Config) => {
  const { MoengageConfig } = await import('./moengage')
  moengageInstance = new MoengageConfig(config)
  activeAnalyticsProviders.push(moengageInstance)
  return moengageInstance
}

export async function initAnalytics(config: Config) {
  // const _mixpanel = await initMixpanel(config)
  const _moengage = await initMoengage(config)
  activeAnalyticsProviders = [_moengage]
}

export function publishEvent(eventName: string, eventPayload?: EventPayload) {
  if (!(blockedEvents.includes(eventName) && APP_NAME === 'zet-app')) {
    callProviderFunctions('sendEvent', eventName, eventPayload)
  }
}

export function registerUser(user: User) {
  callProviderFunctions('setInitialUserProperties', user)
}

export function addUserProperties(user: User) {
  callProviderFunctions('setUserProperties', user)
}

export function flushEvents() {
  callProviderFunctions('flushEvents')
}

export function optOutEvents() {
  callProviderFunctions('optOutEvents')
}

export function optInEvents() {
  callProviderFunctions('optInEvents')
}

export function resetAnalytics() {
  callProviderFunctions('reset')
}

export function registerMoengageUser(user: User) {
  moengageInstance?.setInitialUserProperties(user)
}

export function registerMixpanelUser(user: User) {
  // mixpanelInstance?.setInitialUserProperties(user)
}

// export const mixpanel = activeAnalyticsProviders?.[0]
export const moengage = activeAnalyticsProviders?.[0]
